import { PageHeader } from '@core/components/PageHeader';
import { SearchBar } from '@core/components/SearchBar';
import { Button, makeStyles } from '@material-ui/core';
import React, { useContext } from 'react';
import { FaUsers } from 'react-icons/fa';
import { ClienteContext } from '../../ClienteContext';
import { clienteModais } from '../modal/clienteModais';

const searchHeaderClienteStyles = makeStyles({
  searchBarContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-end',
    maxWidth: '512px',
  },
  link: {
    color: '#53c4e6',
    fontWeight: '600',
    textTransform: 'none',
  },
});

const SearchHeader = () => {
  const [search, setSearch] = useContext(ClienteContext).search;
  const [, setModal] = useContext(ClienteContext).modal;

  const handleOpenBuscaAvancada = () => {
    setModal(clienteModais.buscaAvancada);
  };

  const styles = searchHeaderClienteStyles();

  return (
    <PageHeader title="Clientes" icon={<FaUsers />}>
      <div className={`${styles.searchBarContainer}`}>
        <div className="flex items-center w-full max-w-512 stepBarraPesquisa">
          <SearchBar searchText={search} onChange={setSearch} />
        </div>
        <div className="stepBuscaAvancada">
          <Button className={styles.link} onClick={handleOpenBuscaAvancada}>
            Busca avançada
          </Button>
        </div>
      </div>
    </PageHeader>
  );
};

export default SearchHeader;
